(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var shouldReconcileOnLoad = document.currentScript && document.currentScript.hasAttribute('data-initial-reconcile');
  var busy = false, timer = null, lastCart = null;

  /* Mirrors the exact discovery pattern from sections/lp-main-product.liquid ~line 1649-1650:
     var drawerEl = document.querySelector('hdt-cart-drawer');
     var drawerSectionId = drawerEl ? drawerEl.getAttribute('section-id') : null;
     The cart drawer (sections/cart-drawer.liquid line 14) renders:
       <hdt-cart-drawer ... section-id="{{ section.id }}" ...>
  */
  function drawerSectionId() {
    var el = document.querySelector('hdt-cart-drawer');
    return el ? el.getAttribute('section-id') : null;
  }

  async function getDecision() {
    var res = await fetch(root + '?section_id=lp-obsequio-cart');
    if (!res.ok) throw new Error('decision');
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.getElementById('lp-obsequio-decision');
    if (!el) throw new Error('no-decision');
    return JSON.parse(el.textContent.trim());
  }

  async function getCart() {
    if (lastCart && lastCart.items) return lastCart;
    return fetch(root + 'cart.js').then(function (r) { return r.json(); });
  }

  function onCartPageWithoutDrawer() { return !drawerSectionId() && !!document.getElementById('CartPage-Form'); }

  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }

  /* Obsequios por nivel (se suman): una línea por nivel cumplido, con _obsequio_nivel = handle del
     metaobjeto y cantidad 1. Cualquier otra línea con la variante de un regalo de nivel se quita,
     incluida una agregada a mano sin la propiedad. No toca las líneas _obsequio_auto (obsequio de marca). */
  async function reconcileTiers(decision, cart) {
    var tiers = decision.tiers || [];
    if (!tiers.length && !cart.items.some(function (i) { return i.properties && i.properties._obsequio_nivel; })) return false;
    var giftVariants = tiers.map(function (t) { return t.variant; });
    var seen = {}, changed = false;
    for (var i = 0; i < cart.items.length; i++) {
      var line = cart.items[i];
      var handle = line.properties && line.properties._obsequio_nivel;
      if (!handle && giftVariants.indexOf(line.variant_id) === -1) continue;
      if (line.properties && line.properties._obsequio_auto === '1') continue;
      var tier = handle && tiers.filter(function (t) { return t.handle === handle; })[0];
      if (!tier || !tier.met || tier.variant !== line.variant_id || seen[handle]) {
        await post('cart/change.js', { id: line.key, quantity: 0 });
        changed = true;
      } else {
        seen[handle] = true;
        if (line.quantity !== 1) { await post('cart/change.js', { id: line.key, quantity: 1 }); changed = true; }
      }
    }
    var toAdd = tiers.filter(function (t) { return t.met && !seen[t.handle]; }).map(function (t) {
      return { id: t.variant, quantity: 1, properties: { _obsequio_nivel: t.handle } };
    });
    if (toAdd.length) { await post('cart/add.js', { items: toAdd }); changed = true; }
    return changed;
  }

  async function dispatchFresh() {
    var sid = drawerSectionId();
    /* En /cart no hay cajón: la página usa índices de línea que cambian al entrar o salir un obsequio,
       así que se recarga para que +/− y "Quitar" apunten a la línea correcta. */
    if (onCartPageWithoutDrawer()) { window.location.reload(); return; }
    var fresh = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
    if (sid) {
      var secRes = await fetch(root + '?section_id=' + encodeURIComponent(sid));
      if (secRes.ok) { fresh.sections = {}; fresh.sections[sid] = await secRes.text(); }
    }
    document.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true, detail: { baseEvent: 'lp:obsequio:reconcile', cart: fresh }
    }));
  }

  async function reconcile() {
    var decision, cart;
    try { decision = await getDecision(); cart = await getCart(); }
    catch (e) { return; } // degrade safely: never break the cart

    var tiersChanged = false;
    try {
      tiersChanged = await reconcileTiers(decision, cart);
      if (tiersChanged) cart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
    } catch (e) { /* si falla, el obsequio de marca sigue su curso */ }

    var desired = decision.should_be_in_cart ? decision.gift_variant : null;
    var autoLines = cart.items.filter(function (i) { return i.properties && i.properties._obsequio_auto === '1'; });
    var autoDesired = autoLines.filter(function (i) { return i.variant_id === desired; });
    var commercialDesired = cart.items.filter(function (i) {
      return i.variant_id === desired && !(i.properties && i.properties._obsequio_auto === '1');
    });

    /* Shopify aplica un BXGY por variante, no por propiedades de línea. Si el
       cliente ya llevaba ese producto como venta, puede regalar la línea vieja
       y cobrar la línea automática. Reinsertamos primero el obsequio y después
       la venta para que la asignación $0 quede siempre en `_obsequio_auto`. */
    var wrongLineHasDiscount = commercialDesired.some(function (i) { return i.final_price === 0; });
    var autoLineIsCharged = autoDesired.some(function (i) { return i.final_price > 0; });
    if (desired && wrongLineHasDiscount && autoLineIsCharged) {
      var commercialCopies = commercialDesired.map(function (i) {
        return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} };
      });
      var linesToReset = autoDesired.concat(commercialDesired);
      try {
        for (var resetIndex = 0; resetIndex < linesToReset.length; resetIndex++) {
          await fetch(root + 'cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: linesToReset[resetIndex].key, quantity: 0 })
          });
        }
        var giftProperties = { _obsequio_auto: '1' };
        if (decision.gift_source_type) giftProperties._obsequio_source_type = String(decision.gift_source_type);
        if (decision.gift_source_id) giftProperties._obsequio_source_id = String(decision.gift_source_id);
        await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: desired, quantity: 1, properties: giftProperties }] })
        });
        if (commercialCopies.length) {
          await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: commercialCopies })
          });
        }
        finalCart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
        if (onCartPageWithoutDrawer()) { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true, detail: { baseEvent: 'lp:obsequio:reconcile', cart: finalCart }
        }));
      } catch (e) { /* leave the cart untouched if normalization fails */ }
      return;
    }
    var hasDesired = autoDesired.length > 0;
    var toRemove = autoLines.filter(function (i) { return i.variant_id !== desired; });
    var needAdd = !!(desired && !hasDesired);
    if (toRemove.length === 0 && !needAdd) { // idempotent: nothing to do
      if (tiersChanged) { try { await dispatchFresh(); } catch (e) { /* degrade */ } }
      return;
    }

    var sid = drawerSectionId();

    // Remove stale auto-gift lines (wrong variant or gift no longer desired)
    for (var k = 0; k < toRemove.length; k++) {
      try {
        await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: toRemove[k].key, quantity: 0 })
        });
      } catch (e) { return; }
    }

    var finalCart = null;
    var sectionsData = null;

    // remove-only: fetch fresh drawer HTML via Section Rendering API so the
    // drawer re-renders immediately (cart/change.js does not accept sections param)
    if (!needAdd && sid && toRemove.length) {
      try {
        var secRes = await fetch(root + '?section_id=' + encodeURIComponent(sid));
        if (secRes.ok) {
          var secHtml = await secRes.text();
          sectionsData = {};
          sectionsData[sid] = secHtml;
        }
      } catch (e) { /* degrade: drawer updates on next user action */ }
    }

    if (needAdd) {
      // Mirror lp-main-product ~lines 1653-1654: pass sections so drawer re-renders
      var giftProperties = { _obsequio_auto: '1' };
      if (decision.gift_source_type) giftProperties._obsequio_source_type = String(decision.gift_source_type);
      if (decision.gift_source_id) giftProperties._obsequio_source_id = String(decision.gift_source_id);
      var addBody = {
        items: [{ id: desired, quantity: 1, properties: giftProperties }]
      };
      if (sid) {
        addBody.sections = sid;
        addBody.sections_url = window.location.pathname;
      }
      try {
        var addRes = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addBody)
        });
        if (addRes.ok) {
          var added = await addRes.json();
          // Mirror lp-main-product ~line 1679: attach sections HTML for drawer render
          if (added && added.sections) sectionsData = added.sections;
        }
      } catch (e) { return; }
    }

    try {
      finalCart = await fetch(root + 'cart.js').then(function (r) { return r.json(); });
    } catch (e) { return; }

    // Attach sections so the cart drawer can re-render (mirrors lp-main-product ~line 1679)
    if (sectionsData) finalCart.sections = sectionsData;
    if (onCartPageWithoutDrawer()) { window.location.reload(); return; }

    // Mirror lp-main-product ~lines 1683-1686: dispatch cart:change with cart detail.
    // baseEvent: 'lp:obsequio:reconcile' is the anti-loop sentinel — the listener at the
    // bottom of this IIFE skips events with this value, preventing infinite reconcile.
    document.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'lp:obsequio:reconcile', cart: finalCart }
    }));
  }

  var again = false;
  function run() {
    clearTimeout(timer);
    timer = setTimeout(async function () {
      // Si llega un cambio mientras se reconcilia, se repite al terminar (no se pierde).
      if (busy) { again = true; return; }
      busy = true;
      try { await reconcile(); } catch (e) { /* degrade */ } finally {
        busy = false; lastCart = null;
        if (again) { again = false; run(); }
      }
    }, 300);
  }

  // Anti-loop guard: skip events we dispatched ourselves (baseEvent === 'lp:obsequio:reconcile').
  // Also guarded by: busy flag (no re-entry while running) + 300 ms debounce (collapses rapid events).
  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.baseEvent === 'lp:obsequio:reconcile') return;
    lastCart = (e.detail && e.detail.cart) || null;
    run();
  });

  // A mutation always reconciles the gift. A cold-load reconciliation is only
  // needed on /cart; doing it globally caused two startup requests on every URL.
  if (shouldReconcileOnLoad) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }
})();
